/**
 *  @class
 *  @function ArticleNavigation
 */
if (!customElements.get('article-navigation')) {
  class ArticleNavigation extends HTMLElement {
    constructor() {
      super();
      this._rafId = null;
    }
    connectedCallback() {
      window.setTimeout(() => {
        this.progress_bar = document.getElementById('progress-bar');
        this.article_element = document.getElementById('main-article');
        this.title_element = document.getElementById('post-title-wrapper');
        this._headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;

        this._boundOnScroll = this._onScroll.bind(this);
        window.addEventListener('scroll', this._boundOnScroll, { passive: true });
        window.dispatchEvent(new Event('scroll'));
      });
    }
    _onScroll() {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this._rafId = null;

        // Batch all reads
        const scrollY = window.scrollY;
        const articleRect = this.article_element.getBoundingClientRect();
        const titleRect = this.title_element.getBoundingClientRect();
        const articleTop = articleRect.top + scrollY;
        const articleHeight = this.article_element.offsetHeight;
        const titleTop = titleRect.top + scrollY;
        const titleHeight = this.title_element.offsetHeight;

        // Calculate values
        const pixelScrolled = scrollY - articleTop - titleTop + this._headerHeight;
        const pixelsToPercentage = Math.max(pixelScrolled / articleHeight, 0);
        const titleOffset = titleTop + titleHeight;
        const articleOffset = articleTop + articleHeight;

        // Batch all writes
        this.progress_bar.style.transform = 'scale(' + pixelsToPercentage + ', 1)';

        if (scrollY > articleOffset) {
          this.classList.remove('navigation--sticky');
        } else if (scrollY > titleOffset) {
          this.classList.add('navigation--sticky');
        } else {
          this.classList.remove('navigation--sticky');
        }
      });
    }
  }
  customElements.define('article-navigation', ArticleNavigation);
}